import type { UserOverridesItemRequest } from 'js/src/client';

export enum USER_OVERRIDES_ACTIONS {
    HYDRATE_OVERRIDES = 'HYDRATE_OVERRIDES',
    SET_SCENE_TEXT_POS_OVERRIDE = 'SET_SCENE_TEXT_POS_OVERRIDE',
    SET_SCENE_TEXT_SIZE_OVERRIDE = 'SET_SCENE_TEXT_SIZE_OVERRIDE',
    SET_SCENE_TEXT_ALIGNMENT_OVERRIDE = 'SET_SCENE_TEXT_ALIGNMENT_OVERRIDE',
    SET_SCENE_DURATION_OVERRIDE = 'SET_SCENE_DURATION_OVERRIDE',
    SET_SCENE_CROP_OVERRIDE = 'SET_SCENE_CROP_OVERRIDE',
    SET_SCENE_KEN_BURN_OVERRIDE = 'SET_SCENE_KEN_BURN_OVERRIDE',
    SET_SCENE_BRIGHTNESS_OVERRIDE = 'SET_SCENE_BRIGHTNESS_OVERRIDE',
    SET_SCENE_OVERRIDES = 'SET_SCENE_OVERRIDES',
}

// map of <scene id> to overrides
export type UserOverrides = Record<string, UserOverridesItemRequest>;

export const DEFAULT_USER_OVERRIDES = {
    DURATION: false,
    TEXT_POSITION: false,
    TEXT_SIZE: false,
    TEXT_ALIGNMENT: false,
    BACKGROUND_TRANSFORM: false,
    BACKGROUND_ANIMATION: false,
    BRIGHTNESS: false,
};
